import gql from 'graphql-tag';

const FRAGMENT = gql`    
    fragment User on users {
        id: user_id
        sub: user_cognito_sub
        fname: user_first_name
        lname: user_last_name
        user_preferred_name
        gender_pronounce
        user_phone
        timezone
        state
    }
    fragment FCProfile on fc_profile {
        id
        user_id
        bio
    }
`;
export const GET_PROFILE = gql`
    query getUserProfile($id: Int!) {
        user: users_by_pk(user_id: $id) {
            ...User
        }
        profiles: fc_profile(where:{user_id:{_eq:$id}}) {
            ...FCProfile
       }
    }
    ${FRAGMENT}
`;

export const UPDATE_PROFILE = gql`
    mutation update($input: fc_profile_insert_input!) {
        insert_fc_profile_one(object:$input, on_conflict:{
          constraint:fc_profile_user_id_key,
          update_columns:bio,
        }) {
            ...FCProfile
        }
    }
    ${FRAGMENT}
`;
